import { useMediaQuery } from '@material-ui/core';
import TrashIcon from 'images/icons/signals/removesAndDeletes/trashNavyBlueWithYellowX.svg';
import { ValidityFilterBox } from '../../styles';

function SimplifiedValidityCards({
  onClick,
  hasSelectedProduct,
  validityFilterInfos
}) {
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const isMobileScreen = useMediaQuery('(max-width: 866px)');
  const expiredInfos = validityFilterInfos?.content?.find(
    (filter) => filter?.labelStatus === 'EXPIRED'
  );
  const onDateInfos = validityFilterInfos?.content?.find(
    (filter) => filter?.labelStatus === 'ON_DATE'
  );
  const validInfos = validityFilterInfos?.content?.find(
    (filter) => filter?.labelStatus === 'VALID'
  );

  const FILTERS = [
    {
      label: 'ONTEM',
      key: 'EXPIRED',
      colorClass: 'expired',
      total: expiredInfos?.total || 0
    },
    {
      label: 'HOJE',
      key: 'ON_DATE',
      colorClass: 'onDate',
      total: onDateInfos?.total || 0
    },
    {
      label: 'AMANHÃ',
      key: 'VALID',
      colorClass: 'valid',
      total: validInfos?.total || 0
    }
  ];

  const buildTotalValueText = (filter) => {
    let text = `${filter.label}: ${filter?.total}`;

    if (isMobileScreen) text = `QTDE: ${filter?.total}`;

    if (isPhoneScreen) text = filter?.total;

    return text;
  };

  return (
    <ValidityFilterBox
      filterOpen
      simplifiedVersion
      hasSelectedProduct={hasSelectedProduct}
    >
      {FILTERS.map((filter) => {
        return (
          <div
            key={filter.key}
            className={`validityCard ${filter.colorClass}`}
            onClick={() => {
              onClick();
            }}
          >
            <div
              className={`labelAndValue ${
                filter.colorClass === 'expired'
                  ? 'justifyBetween'
                  : 'justifyEnd'
              }`}
            >
              {filter.colorClass === 'expired' && (
                <img
                  style={{ width: '16px' }}
                  src={TrashIcon}
                  alt="BarCodeIcon"
                />
              )}

              {buildTotalValueText(filter)}
            </div>
          </div>
        );
      })}
    </ValidityFilterBox>
  );
}

export default SimplifiedValidityCards;
